import { formatEnum } from "../Home/helpers/formatters";

export enum TipoComision {
  DEPORTIVA_VENTA = "DEPORTIVA_VENTA",
  DEPORTIVA_CLASE = "DEPORTIVA_CLASE",
  DEPORTIVA_COORDINACION = "DEPORTIVA_COORDINACION",
  ASESOR_VENTA = "ASESOR_VENTA",
  ASESOR_REACTIVACION = "ASESOR_REACTIVACION",
  ASESOR_INTEGRANTE = "ASESOR_INTEGRANTE",
  LIDER_COMERCIAL_VENTA = "LIDER_COMERCIAL_VENTA",
  LIDER_COMERCIAL_REACTIVACION = "LIDER_COMERCIAL_REACTIVACION",
  LIDER_COMERCIAL_INTEGRANTE = "LIDER_COMERCIAL_INTEGRANTE",
  ASESOR_VENTA_PREAPERTURA = "ASESOR_VENTA_PREAPERTURA",
  ASESOR_REACTIVACION_PREAPERTURA = "ASESOR_REACTIVACION_PREAPERTURA",
  ASESOR_INTEGRANTE_PREAPERTURA = "ASESOR_INTEGRANTE_PREAPERTURA",
  LIDER_COMERCIAL_VENTA_PREAPERTURA = "LIDER_COMERCIAL_VENTA_PREAPERTURA",
  LIDER_COMERCIAL_REACTIVACION_PREAPERTURA = "LIDER_COMERCIAL_REACTIVACION_PREAPERTURA",
  LIDER_COMERCIAL_INTEGRANTE_PREAPERTURA = "LIDER_COMERCIAL_INTEGRANTE_PREAPERTURA",
  LIDER_COMERCIAL_BONO_CONSOLIDADO = "LIDER_COMERCIAL_BONO_CONSOLIDADO",
  GERENTE_REGIONAL_BONO_CONSOLIDADO = "GERENTE_REGIONAL_BONO_CONSOLIDADO",
  ASESOR_ANUALIDAD = "ASESOR_ANUALIDAD",
  GERENTE_REGIONAL_ANUALIDAD = "GERENTE_REGIONAL_ANUALIDAD",
  ASESOR_ANUALIDAD_BONO = "ASESOR_ANUALIDAD_BONO",
  CHATER_CITA_CONFIRMADA = "CHATER_CITA_CONFIRMADA",
  SUPERVISOR_CITA_CONFIRMADA = "SUPERVISOR_CITA_CONFIRMADA",
  SUPERVISOR_CONVERSION_BONO = "SUPERVISOR_CONVERSION_BONO",
  CHATER_ANUALIDAD = "CHATER_ANUALIDAD",
  CHATER_ANUALIDAD_BONO = "CHATER_ANUALIDAD_BONO",
  SUPERVISOR_ANUALIDAD = "SUPERVISOR_ANUALIDAD",
  SUPERVISOR_ANUALIDAD_BONO = "SUPERVISOR_ANUALIDAD_BONO"
}

export function descTipoComision(tipoComision: TipoComision) {
  // Enum
  switch (tipoComision) {
    case TipoComision.DEPORTIVA_VENTA:
      return "Deportiva - Venta";
    case TipoComision.DEPORTIVA_CLASE:
      return "Deportiva - Clase";
    case TipoComision.DEPORTIVA_COORDINACION:
      return "Deportiva - Coordinación";
    case TipoComision.ASESOR_VENTA:
      return "Asesor - Venta";
    case TipoComision.ASESOR_REACTIVACION:
      return "Asesor - Reactivación";
    case TipoComision.ASESOR_INTEGRANTE:
      return "Asesor - Integrante";
    case TipoComision.LIDER_COMERCIAL_VENTA:
      return "Líder Comercial - Venta";
    case TipoComision.LIDER_COMERCIAL_REACTIVACION:
      return "Líder Comercial - Reactivación";
    case TipoComision.LIDER_COMERCIAL_INTEGRANTE:
      return "Líder Comercial - Integrante";
    case TipoComision.ASESOR_VENTA_PREAPERTURA:
      return "Asesor - Venta (Preapertura)";
    case TipoComision.ASESOR_REACTIVACION_PREAPERTURA:
      return "Asesor - Reactivación (Preapertura)";
    case TipoComision.ASESOR_INTEGRANTE_PREAPERTURA:
      return "Asesor - Integrante (Preapertura)";
    case TipoComision.LIDER_COMERCIAL_VENTA_PREAPERTURA:
      return "Líder Comercial - Venta (Preapertura)";
    case TipoComision.LIDER_COMERCIAL_REACTIVACION_PREAPERTURA:
      return "Líder Comercial - Reactivación (Preapertura)";
    case TipoComision.LIDER_COMERCIAL_INTEGRANTE_PREAPERTURA:
      return "Líder Comercial - Integrante (Preapertura)";
    case TipoComision.LIDER_COMERCIAL_BONO_CONSOLIDADO:
      return "Líder Comercial - Bono Consolidado";
    case TipoComision.GERENTE_REGIONAL_BONO_CONSOLIDADO:
      return "Regional - Bono Consolidado";
    default:
      return formatEnum(tipoComision);
  }
}

export interface ComisionAlcancePorcentaje {
  id?: number;
  idComisionAlcance?: number;
  importeComision: number;
  rangoInicial: number;
  rangoFinal: number;
  sustitutoVendedorNuevo: boolean;
  comisionPorcentual: boolean;
}

export default interface ComisionAlcance {
  id?: number;
  idMembresia: number;
  membresia: string;
  tipoComision: TipoComision;
  precioVentaEsperado: number;
  aplicaPromo: boolean;
  porcentajes?: ComisionAlcancePorcentaje[];
}
